import React, { useRef, useState, useEffect } from "react";
import { useI18next } from "gatsby-plugin-react-i18next";
import CN from "classnames";
import styled from "styled-components";
import { lighten } from "polished";
import { useInView } from "react-intersection-observer";
import Ticker from "react-ticker";
import { useWindowWidth } from "@react-hook/window-size";
import Observer from "@researchgate/react-intersection-observer";

import { EditorJsRenderer } from "~/src/components/editorjs";
import { Container } from "~/src/components";
import {
    down,
    grid_down,
    spacings,
    colors,
    base_colors,
    fonts,
    global,
} from "~/src/config/vars";

import {
    past_projects_ru,
    past_projects_kg,
} from "./block_about_text/past_projects";
import { directions_ru, directions_kg } from "./block_about_text/directions";
import { what_awaits_ru, what_awaits_kg } from "./block_about_text/what_awaits";

import background_mask from "~/src/images/background_mask.png";

const BlockAbout = () => {
    const { language } = useI18next();
    const onlyWidth = useWindowWidth();
    const widthRef = useRef(null);
    const [widthRight, setWidthRight] = useState(null);
    const [visible3, setVisible3] = useState(false);

    const [ref, inView] = useInView({
        threshold: 0,
    });

    useEffect(() => {
        setWidthRight(widthRef.current.clientWidth);
    }, [widthRight]);

    const handleVisibility3 = ({ isIntersecting }) => {
        setVisible3(isIntersecting);
    };

    const ru = language === "ru";
    return (
        <SBlockAbout className="bg" ref={ref}>
            <div
                ref={widthRef}
                className={CN(`bg_color`, {
                    visible3: visible3 === true,
                })}
            />
            <Container size="large">
                <SBlock className="first">
                    <SContent>
                        <EditorJsRenderer
                            blocks={ru ? past_projects_ru : past_projects_kg}
                        />
                    </SContent>
                    <SRight>
                        {widthRight ? (
                            <STitleWrap style={{ width: widthRight }}>
                                <Ticker move={inView}>
                                    {() => (
                                        <STitle>
                                            <span>Media</span>
                                            <span>Jasa</span>
                                        </STitle>
                                    )}
                                </Ticker>
                            </STitleWrap>
                        ) : onlyWidth < grid_down.lg ? (
                            <STitleWrap style={{ width: "100%" }}>
                                <Ticker move={inView}>
                                    {() => (
                                        <STitle>
                                            <span>Media</span>
                                            <span>Jasa</span>
                                        </STitle>
                                    )}
                                </Ticker>
                            </STitleWrap>
                        ) : null}
                    </SRight>
                </SBlock>
            </Container>
            <Container size="large">
                <SBlock className="center">
                    <SContent>
                        <EditorJsRenderer
                            blocks={ru ? directions_ru : directions_kg}
                        />
                    </SContent>
                    <SRight>
                        {widthRight ? (
                            <STitleWrap style={{ width: widthRight }}>
                                <Ticker move={inView}>
                                    {() => (
                                        <STitle>
                                            {ru ? (
                                                <>
                                                    <span>Направления</span>
                                                    <span>Направления</span>
                                                    <span>Направления</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span>Багыттар</span>
                                                    <span>Багыттар</span>
                                                    <span>Багыттар</span>
                                                </>
                                            )}
                                        </STitle>
                                    )}
                                </Ticker>
                            </STitleWrap>
                        ) : onlyWidth < grid_down.lg ? (
                            <STitleWrap style={{ width: "100%" }}>
                                <Ticker move={inView}>
                                    {() => (
                                        <STitle>
                                            {ru ? (
                                                <>
                                                    <span>Направления</span>
                                                    <span>Направления</span>
                                                    <span>Направления</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span>Багыттар</span>
                                                    <span>Багыттар</span>
                                                    <span>Багыттар</span>
                                                </>
                                            )}
                                        </STitle>
                                    )}
                                </Ticker>
                            </STitleWrap>
                        ) : null}
                    </SRight>
                </SBlock>
            </Container>
            <Container size="large">
                <SBlock className="last">
                    <SContent>
                        <Observer onChange={handleVisibility3} threshold={1}>
                            <EditorJsRenderer
                                blocks={ru ? what_awaits_ru : what_awaits_kg}
                            />
                        </Observer>
                    </SContent>
                    <SRight>
                        {widthRight ? (
                            <STitleWrap style={{ width: widthRight }}>
                                <Ticker move={inView}>
                                    {() => (
                                        <STitle>
                                            {ru ? (
                                                <>
                                                    <span>Что</span>
                                                    <span>тебя</span>
                                                    <span>ждёт</span>
                                                    <span>в</span>
                                                    <span>MediaJasa?</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span>MediaJasa</span>
                                                    <span>менен</span>
                                                    <span>сизди</span>
                                                    <span>эмне</span>
                                                    <span>күтүп</span>
                                                    <span>турат?</span>
                                                </>
                                            )}
                                        </STitle>
                                    )}
                                </Ticker>
                            </STitleWrap>
                        ) : onlyWidth < grid_down.lg ? (
                            <STitleWrap style={{ width: "100%" }}>
                                <Ticker move={inView}>
                                    {() => (
                                        <STitle>
                                            {ru ? (
                                                <>
                                                    <span>Что</span>
                                                    <span>тебя</span>
                                                    <span>ждёт</span>
                                                    <span>в</span>
                                                    <span>MediaJasa?</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span>MediaJasa</span>
                                                    <span>менен</span>
                                                    <span>сизди</span>
                                                    <span>эмне</span>
                                                    <span>күтүп</span>
                                                    <span>турат?</span>
                                                </>
                                            )}
                                        </STitle>
                                    )}
                                </Ticker>
                            </STitleWrap>
                        ) : null}
                    </SRight>
                </SBlock>
            </Container>
        </SBlockAbout>
    );
};

const container_space_width = `(((100% - ${global?.container_width}) / 2) + 4vw)`;

const SBlockAbout = styled.div`
    --about-content-width: 760px;
    ${down("xl")} {
        --about-content-width: 660px;
    }
    /*  */
    position: relative;
    background-color: ${lighten(0.05, base_colors.color_beige)};
    .bg_color {
        content: "";
        position: absolute;
        width: calc(
            ((100% - var(--about-content-width)) - ${container_space_width})
        );
        height: 100%;
        top: 0;
        left: auto;
        right: 0;
        background-color: ${colors?.violet_base};
        transition: all 0.3s;
        ${down("lg")} {
            display: none;
        }
        &.visible3 {
            background-color: ${colors?.black_light};
            /* background-color: ${colors?.blue_active}; */
        }
    }
    div&:after {
        width: calc(
            ((100% - var(--about-content-width)) - ${container_space_width})
        );
        left: auto;
        right: 0;
        background-color: ${colors?.white};
        ${down("lg")} {
            display: none;
        }
    }
`;
const SBlock = styled.div`
    display: flex;
    align-items: stretch;
    ${down("lg")} {
        flex-wrap: wrap;
    }
`;
const SContent = styled.div`
    font-size: ${fonts?.fs_18};
    width: var(--about-content-width);
    flex: 0 0 var(--about-content-width);
    padding: 0 50px ${spacings?.offset_40} 0;
    ${down("lg")} {
        width: 100%;
        flex: 0 0 100%;
        padding-right: 0;
        order: 2;
    }
    .first & {
        padding-top: ${spacings?.offset_80};
        ${down("lg")} {
            padding-top: 0;
        }
    }
    .last & {
        padding-bottom: ${spacings?.offset_80};
    }
`;

const SRight = styled.div`
    position: relative;
    flex: 1;
    ${down("lg")} {
        order: 1;
        flex: auto;
    }
    ${down("lg")} {
        width: 100vh;
        margin: 0 calc(0.0000001px - (${spacings?.offset_wrapper}));
        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;
            pointer-events: none;
            mask: url(${background_mask}) repeat 0 0/50vw 30vw;
            z-index: 0;
            background-color: ${colors.white};
        }
    }
    .first & {
        padding-top: ${spacings?.offset_80};
        padding-bottom: ${spacings?.offset_80};
        ${down("lg")} {
            padding-bottom: ${spacings?.offset_20};
            background-color: ${colors?.black_light};
        }
    }
    .center & {
        padding-bottom: ${spacings?.offset_80};
        ${down("lg")} {
            padding-top: ${spacings?.offset_20};
            padding-bottom: ${spacings?.offset_20};
            background-color: ${colors?.violet_base};
        }
    }
    .last & {
        padding-bottom: ${spacings?.offset_80};
        ${down("lg")} {
            padding-top: ${spacings?.offset_20};
            padding-bottom: ${spacings?.offset_20};
            background-color: ${colors?.violet_base};
        }
    }
`;

const STitleWrap = styled.div`
    position: sticky;
    top: 1em;
    z-index: 2;
    font-size: ${fonts?.fs_64};
    color: ${colors?.white};
    font-weight: ${fonts?.fw_black};
    text-transform: uppercase;
    white-space: nowrap;
    ${down("lg")} {
        position: relative;
        top: 0;
        color: ${colors?.violet_base};
    }
    ${down("sm")} {
        font-size: ${fonts?.fs_32};
    }
`;
const STitle = styled.div`
    span {
        margin-right: 0.3em;
        .first & {
            background-color: ${colors?.black};
            color: ${colors?.beige_base};
            font-size: ${fonts?.fs_20};
        }
        .center & {
            background-color: ${colors?.blue_base};
            color: ${colors?.beige_base};
        }
        .last & {
            background-color: ${colors?.beige_base};
            color: ${colors?.violet_active};
        }
    }
`;

export default BlockAbout;
